import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5d5a5124&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5a5124')) {
      api.createRecord('5d5a5124', component.options)
    } else {
      api.reload('5d5a5124', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5d5a5124&", function () {
      api.rerender('5d5a5124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/demand-notice/index.vue"
export default component.exports